module.exports = __webpack_public_path__ + "5b090657ff44860f34f29469e03a69cd.fbx";